<div class="flex flex-col ml-60 mr-60">
    <h2 class="mat-headline-5 mt-20 ml-18 mb-0">{{'TENANT_LAYOUT.SERVICE_DEFINITION.SERVICE_DEFINITION' | transloco}}</h2>
      <!-- <div class="flex flex-row flex-wrap justify-start items-center pt-6 pl-24 pr-24 pb-10 w-50-percent">
        <ng-container *ngIf="selectedSolution">
          <span>{{ 'INSTANCE_STATUS.solution' | transloco }}: </span>
          <span class="flex justify-center items-center btn-rounded mat-body-1 fw-500 pl-12 pr-12 pt-4 pb-4 mr-10 ml-12">
            {{selectedSolution}}
            <mat-icon svgIcon="close" class="ml-6 icon-sm cursor-pointer" (click)="closeMenu(selectedSolution)"></mat-icon>
          </span>
        </ng-container>
        <span *ngIf="selectedSolution" class="flex justify-center items-center mat-subtitle-2 mb-0 fw-500 cursor-pointer warn-solid-fg"
          (click)="resetFilter()">
          {{ 'BUTTONS.CLEAR_ALL' | transloco }}
        </span>
      </div> -->
    <div *ngIf="initialBluePrints?.length > 0|| initialsolutionVersions?.length > 0" class="flex flex-row justify-between items-center pt-20 pb-10 pl-16 pr-16">
      <div class="service-def-search">
        <app-search-box (keyup)="searchBlueprint($event)" [placeholder]="'TENANT_LAYOUT.SERVICE_DEFINITION.SEARCH_BY_NAME'"></app-search-box>
      </div>
      <!-- <div [ngClass]="{'disabled': !filterEnable}">
        <button class="flex justify-center items-center context-menu-icon" (click)="filterColumns()">
          <mat-icon class="mr-4" svgIcon="filter_alt"></mat-icon>
          <span class="mat-body-1 fw-500">{{'SOLUTIONS.FILTERS' | transloco }}</span>
        </button>
      </div> -->
      @if(permissionsMap[PermissionKeys.BLUEPRINT_CREATE] && !isExternalTenant) {
      <div>
        <button  type="button" class="flex justify-center items-center tenant-gradient mat-subtitle-2 service-def-btn" mat-button (click)="createServiceDefinition()">
          <mat-icon svgIcon="add" class="icon-md-2 pr-4"></mat-icon>
          {{'TENANT_LAYOUT.SERVICE_DEFINITION.CREATE_SERVICE_DEFINITION' | transloco }}
        </button>
      </div>
      }
    </div>
    <!-- displaying empty page when service definition not created-->
    <div *ngIf="initialBluePrints?.length == 0 && !initialLoader" class="flex flex-col empty-panel ml-10 mr-72 mt-24">
      <div class="empty-data flex flex-col items-center mt-60 ">
        <img class="w-106" alt="service definition not found" src="/assets/images/service_not_found.png">
        <div class="flex mt-6 ">{{'TENANT_LAYOUT.SERVICE_DEFINITION.EMPTY_MESSAGE' | transloco }}</div>
      </div>
      @if(!isExternalTenant) {
      <div class="flex justify-center mt-24">
        <button type="button" class="flex justify-center items-center tenant-gradient mat-subtitle-2" mat-button
          (click)="createServiceDefinition()">
          <mat-icon svgIcon="add" class="icon-md-2 pr-4"></mat-icon>
          {{'TENANT_LAYOUT.SERVICE_DEFINITION.CREATE_SERVICE_DEFINITION' | transloco }}
        </button>
      </div>
      }
    </div>
    <div class="flex flex-row flex-wrap">
      <div *ngIf="initialLoader" class="mt-60 w-100-percent flex">
          <ng-container *ngFor="let item of [1,2,3,4]">
            <div class="card-tile p-16 m-16 cursor-pointer">
              <div class="flex flex-row justify-between">
                <ngx-skeleton-loader class="pr-30" count="1" appearance="line"></ngx-skeleton-loader>
              </div>
              <ngx-skeleton-loader class="loader-line pr-30" count="1" appearance="line"></ngx-skeleton-loader>
              <div class="flex flex-col pt-12">
                <ngx-skeleton-loader class="loader-line pr-30" count="2" appearance="line"></ngx-skeleton-loader>
              </div>
            </div>
          </ng-container>
        </div>
      <div class="card-tile m-16 cursor-pointer" *ngFor="let service of serviceDefinitionList" (click)="cardClick(service)">
          <ng-container *ngIf="!dataLoaded; else displayRelease">
            <div class="release-row pt-10 pb-10 flex justify-center">
              <ngx-skeleton-loader class="loader-line pr-30" count="1" appearance="line"></ngx-skeleton-loader>
            </div>
          </ng-container>
          <ng-template #displayRelease>
            <div class="flex flex-row pt-10 pb-10 pl-16 pr-16 fw-600 release-row">
              <mat-icon svgIcon="token" class="icon-md mr-8"></mat-icon>
              {{'TENANT_LAYOUT.SERVICE_DEFINITION.RELEASE_VERSION' | transloco}}
              <ng-container *ngIf="service?.version; else notApplicable">
                {{service?.version}}
                <div *ngIf="service?.isAMR" class="flex flex-row justify-center items-center vertical-dash ml-12 mt-6 pl-10">
                  {{('TENANT_LAYOUT.SERVICE_DEFINITION.AMR' | transloco)}}
                </div>
              </ng-container>
              <ng-template #notApplicable>
                {{'INSTANCE_STATUS.NA' | transloco}}
              </ng-template>
            </div>
          </ng-template>
          <div class="p-16">
            <div class="flex flex-row justify-between">
              <div class="mat-headline-5 solution-names mt-2 mb-12">{{service?.name}}</div>
            </div>
            @if(!isExternalTenant) {
            <ng-container *ngIf="!service?.solutionName; else displaySolution">
              <ngx-skeleton-loader class="loader-line mb-18 pr-30" count="1" appearance="line"></ngx-skeleton-loader>
            </ng-container>
            <ng-template #displaySolution>
              <div class="flex flex-row mb-18">
                <div class="tag-line" [title]="service?.solutionName">{{service?.solutionName}}</div>
              </div>
            </ng-template>
             <mat-divider class="service-def-divider mb-16"></mat-divider>

            <span class="pb-4">{{'TENANT_LAYOUT.SERVICE_DEFINITION.CREATED' | transloco}} {{service?.dateCreated | timeDate}}</span>
            <!-- <div class="flex flex-col pt-12 neutral-color"> -->
              <!-- <ng-container *ngIf="!dataLoaded else region">
                <ngx-skeleton-loader class="loader-line pr-30" count="1" appearance="line"></ngx-skeleton-loader>
              </ng-container>
              <ng-template #region>
                <div class="flex flex-row pr-8 pb-10">
                  <div class="flex flex-row mt-2">
                    <mat-icon svgIcon="place" class="icon-md mr-8"></mat-icon>
                  </div>
                  {{tenant[0] ? (tenant[0]?.regionPair || tenant.temenosRegion) : '-'}}
                </div>
              </ng-template> -->
              
              <!-- <div class="flex flex-row pb-10">
                <mat-icon svgIcon="pages" class="icon-md mr-8"></mat-icon>
              {{'TENANT_LAYOUT.SERVICE_DEFINITION.SERVICE_DEFINITION_VERSION' | transloco}}: {{'INSTANCE_STATUS.NA' | transloco}}
              </div> -->
            <!-- </div> -->
            }
          </div>
      </div>
    </div>

    <div *ngIf="isServiceDefinitionDataLoaded && serviceDefinitionList?.length === 0"
      class="empty-data flex flex-col items-center mt-150">
      <img class="w-106" alt="Data not found" src="/assets/images/service_not_found.png">
      <div class="flex mt-6">{{'TENANT_LAYOUT.SERVICE_DEFINITION.NO_DATA_FOUND' | transloco}}</div>
    </div>
</div>
<div *ngIf="blueprint?.length > 10" class="top-panel ml-72 mr-72 mt-10 mb-10 p-20">
  <app-paginator [length]="blueprint?.length" [pageSizeOptions]="[10, 15, 20]"
    [pageSize]="paginationSize" [pageIndex]="pageIndex" [rangeSize]="3" (page)="pageChanged($event)"></app-paginator>
</div>
